/**
 * Shared overlay surface classes for HeroUI Popover/Tooltip content on dark app
 * chrome. Matches theme-components `variant="inverted"` (light surface, primary text).
 */
export const INVERSE_OVERLAY_SURFACE_CLASS =
  'bg-[var(--surface-default,#ffffff)] text-[var(--text-primary,#0f1d32)] border border-[var(--border-subtle,#e8edf4)] shadow-lg';

/** HeroUI `classNames.content` preset for inverted popovers. */
export const INVERSE_HEROUI_POPOVER_CONTENT_CLASS =
  `${INVERSE_OVERLAY_SURFACE_CLASS} rounded-md`;

/**
 * Dark ink plate for media-preview popovers (presentation Sources, Selected
 * Sources, chat SourceCard). Matches MediaDisplay / Pane / default Popover
 * (``--surface-inverse`` / ink-085). The inverted light overlay above is for
 * menus and copy, not the player chrome (TR-3842).
 */
export const MEDIA_PREVIEW_OVERLAY_SURFACE_CLASS =
  'bg-[var(--surface-inverse,#0f1d32)] text-[var(--text-inverse,#ffffff)] border border-[var(--color-ink-075,#1a263e)] shadow-lg';
